import { NgModule } from 'ng-metadata/core';
import './_layout.scss';

/**
 * @ngdoc module
 * @name mw.components.layout
 * @description
 *
 * Layout
 */
@NgModule({})
export class LayoutModule {}


// WEBPACK FOOTER //
// ./src/lib/components/layout/layout.module.ts